<template>
  <div class="sg_table-inner-wrapper">
    <div class="sg_table-inner">
      <table class="sg__table">
        <thead>
          <tr v-for="row in currentTable.table.slice(0, 1)" :key="row.join(',')" class="sg__table-row">
            <th
              v-for="(cell, j) in row"
              :key="cell"
              :class="['sg__table-cell', { 'isColumnHeader': j === 0 }]"
            >
              {{ cell }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in currentTable.table.slice(1)" :key="row.join(',')" class="sg__table-row">
            <component
              :is="j === 0 ? 'th' : 'td'"
              v-for="(cell, j) in row"
              :key="cell"
              :class="['sg__table-cell', { 'isColumnHeader': j === 0 }]"
            >
              {{ cell }}
            </component>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="sg__radio-btns">
      <div class="sg__radio-btn">
        <input type="radio" v-model="unit" value="inches" name="sizeGuideRadio">
        <span>Inches</span>
      </div>
      <div v-if="!fitType.toLowerCase().includes('footwear')" class="sg__radio-btn">
        <input type="radio" v-model="unit" value="centimeters" name="sizeGuideRadio">
        <span>Centimeters</span>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed, toRefs, ref, watch } from 'vue';

  const props = defineProps({
    bodyMeasurements: {
      type: String,
      required: true,
    },

    fitType: {
      type: String,
      default: null,
    },
  })

  const formatTable = str => {
    return str.value.split('\n').map(row =>
      row
      .split('|')
      .map(str => str.trim())
      .map(str => (str === 'null' ? '' : str))
      .map(str => str.replace(/\"/, '”'))
    )
  }

  const { bodyMeasurements } = toRefs(props)
  const currentTable = ref({ table: formatTable(bodyMeasurements) })  
  const unit = ref('inches')

  watch(unit, val=> {
    currentTable.value = {
      ...currentTable.value,
      table: convertTable(val, currentTable.value.table),
    }
  })

  const convertTable = (unit, table) => {
    if (unit === 'inches') {
      return formatTable(bodyMeasurements)
    }

    const newTable = (table || currentTable).map((row, i) => {
      if (i === 0) return row

      return row.map((cell, i) => {
        if (i === 0) return cell

        return convertNumberCell(unit, cell)
      })
    })
    return newTable
  }

  const convertNumberCell = (unit, cell) => {
    if (unit === 'centimeters') {
      cell = cell.slice(0, -1)
    }

    if (cell.includes('-')) {
      const parts = cell.split('-').map(x => x.trim())

      if (unit === 'centimeters') {
        return parts.map(x => Math.ceil(Number(x) * 2.54 * 2) / 2).join(' - ')
      }
    } else {
      return Math.ceil(Number(cell) * 2.54 * 2) / 2
    }
  }
</script>